import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { success } from "../../utils/helpers.js";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";
import { useSelector } from "react-redux";
import { useDeleteClientMutation } from "../../Redux/services/adminApi.js";

const RemoveModal = ({ setIsOpen, modalData, onRemoveClick, isLoading }) => {

  const handleCancel = () => {
    setIsOpen(false);
  };
  return (
    <>
      <div className="logout-modal-content">
        <div className="flex-custom-center">
          <MdDelete color="red" size={40} className="mb-3" />
        </div>
        <div className="w-100 center-text">
          <h2>Remove</h2>
          <p>Are you sure you want to Remove?</p>
        </div>
        <div className="btn w-100">
          <Button className="cancel-btn w-100" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            disabled={isLoading}
            className="bg-red cancel w-100 mt-3"
            onClick={onRemoveClick}
          >
            {isLoading ? <ThemeSpinner /> : "Remove"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default RemoveModal;
